import { defineComponent, h } from 'vue';
import { Bar } from 'vue-chartjs';
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js';
import 'chartjs-plugin-datalabels';

// Register necessary components from Chart.js
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default defineComponent({
  name: 'BarChartComponent',
  components: {
    Bar
  },
  props: {
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      options: {
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'top',
            padding: 25,
            labels: {
              font: {

              }
            }
          },
          datalabels: { // Disable datalabels for this chart
            display: false
          },
          tooltip: {

          }
        },
        scales: {
          y: {
            stacked: true,
            position: 'left',
            grid: {
              display: false,
              color: "#e4e6e8",
            },
            ticks: {
              maxTicksLimit: 20,
              font: {
                size: 16
              },
            },
            min: 0,
            max: 100
          },
          x: {
            stacked: true,
            grid: {
              display: false
            },
            ticks: {
              font: {
                size: 10
              },
              maxRotation: 0,
              minRotation: 0,
              callback: function (value) {
                return value + '%';
              }
            },
          }
        }
      }
    };
  },
  render() {
    return h('div', { style: { height: '500px' } }, [
      h(Bar, {
        data: this.chartData,
        options: this.options
      })
    ]);
  }
});
